// extracted by mini-css-extract-plugin
export default {"text":"ConfigModal_text__9-OoV","offset":"ConfigModal_offset__yK-G3","modalContainer":"ConfigModal_modalContainer__tWeIK","modalHeader":"ConfigModal_modalHeader__7AQbA"};